interface Opcao {
  valor: string;
  rotulo: string;
}

interface ChipsProps {
  opcoes: Opcao[];
  valor: 'sim' | 'nao' | null;
  aoEscolher: (valor: 'sim' | 'nao') => void;
  /** Nome acessível do grupo, ex.: "Alergias". */
  grupo: string;
}

// Duas pílulas de escolha: 48 px de toque, uma marcada por vez.
export default function Chips({ opcoes, valor, aoEscolher, grupo }: ChipsProps) {
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label={grupo}>
      {opcoes.map((opcao) => {
        const marcada = valor === opcao.valor;
        return (
          <button
            key={opcao.valor}
            type="button"
            aria-pressed={marcada}
            onClick={() => aoEscolher(opcao.valor as 'sim' | 'nao')}
            className={`aperta flex h-12 cursor-pointer items-center justify-center whitespace-nowrap rounded-full border px-4 text-[14px] font-semibold transition-colors ${
              marcada
                ? 'border-primary-500 bg-primary-500 text-white'
                : 'border-secondary-300 bg-white text-foreground-800 hover:bg-background-100'
            }`}
          >
            {opcao.rotulo}
          </button>
        );
      })}
    </div>
  );
}